import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e76943',
      // light:'#3baff6',
      // dark:'#4a51a7'
    },
    secondary: {
      main: '#ffffff',
    },
   
  },
  typography: {
    fontFamily: 'Quicksand-SemiBold, sans-serif',
    fontSize: 16,
    h1: {
      fontFamily: 'Quicksand-Bold, sans-serif',
      fontWeight: 'bold',
      fontSize: '2.5rem',
    },
    h2: {
      fontFamily: 'Quicksand-Bold, sans-serif',
      fontWeight: '400',
      fontSize: '1.5rem',
    },
    h3: {
      fontFamily: 'Quicksand-Medium, sans-serif',
      fontWeight: 500,
      fontSize: '1.5rem',
    },
    h4: {
      fontFamily: 'Quicksand-Medium, sans-serif',
      fontWeight: 500,
      fontSize: '1.2rem',
    },
    h5: {
      fontFamily: 'Quicksand-Medium, sans-serif',
      fontWeight: 500,
      fontSize: '1rem',
    },
    h6: {
      fontFamily: 'Quicksand-Medium, sans-serif',
      fontWeight: 500,
      fontSize: '1rem',
    },
    body1: {
      fontFamily: 'Quicksand-SemiBold, sans-serif',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: 'Quicksand-Regular, sans-serif',
      fontSize: '1rem',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '50px !important',
        },
      },
    },
  },
});


export default theme;